export const state = {
    roles: [],
    systemRole: []
}
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/roles/state.js